export const styles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		paddingTop: '4px'
	},
	button_group: {
		display: 'flex'
	},
	buttons: {
		marginRight: '8px'
	},
	title: {
		fontWeight: 600,
		flexGrow: 1
	},
	dialogContent: {
		position: 'relative'
	},
	dialogActions: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	btnTestEmail: {
		textTransform: 'unset',
		fontSize: '15px',
		marginLeft: '15px'
	},
	actionButtons: {
		textTransform: 'capitalize'
	},
	saveBtn: {
		marginRight: '8px',
		marginLeft: '8px',
		minWidth: 100,
		color: '#fff',
		'& .MuiButton-startIcon': {
			marginRight: '0px'
		}
	},
	iconOffset: {
		minWidth: '24px',
		minHeight: '24px',
		marginRight: '8px'
	},
	modalWrapper: {
		borderRadius: '10px',
		padding: '15px',
		maxWidth: '400px',
		width: '100%',
		display: 'block',
		margin: '0px auto',
		position: 'absolute',
		bottom: '160px',
		left: 0,
		right: 0,
		backgroundColor: '#ffffff',
		zIndex: 1,
		boxShadow: '0px 5px 13px 0px rgba(108,108,108,0.31)'
	},
	contentWrapper: {
		display: 'flex',
		alignItems: 'center',
		fontSize: '15px',
		marginBottom: '30px',
		'@media(max-width: 500px)': {
			flexDirection: 'column',
			alignItems: 'flex-start'
		},
		'& p': {
			margin: '0px 10px 0px 0px',
			whiteSpace: 'nowrap',
			'@media(max-width: 500px)': {
				marginBottom: '5px'
			}
		},
		'& .MuiInputBase-root': {
			border: '1px solid #cccccc',
			borderRadius: '4px',
			boxShadow: 'inset 0 1px 1px rgb(0 0 0 / 8%)',
			color: '#555555',
			height: '34px',
			padding: '10px',
			width: '100%'
		},
		'& .MuiInput-underline:before, & .Mui-focused.MuiInput-underline:after': {
			display: 'none'
		}
	},
	btnSend: {
		textTransform: 'unset',
		fontSize: '15px',
		float: 'right'
	},
	modalBackdrop: {
		width: '100%',
		height: '100%',
		position: 'absolute',
		backdropFilter: 'blur(1px)',
		zIndex: 2
	}
};
